const DEFAULT = 'non-champion';
const CHAMPION = 'champion';

export default {
  DEFAULT,
  CHAMPION
};



// WEBPACK FOOTER //
// ./src/constants/roles.js